import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { HotLead } from '../../types/hotLead';
import { formatCurrency, formatShortDate } from '../../utils/format';
import { ReviewBadge } from './ReviewBadge';
interface LeadTableProps {
  leads: HotLead[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  emptyMessage: string;
}
const columns = ['Name', 'Loan amount', 'Seasoning', 'Loan type', 'Credit pull', 'Stage', 'Disposition', 'Touches', 'Status'];
export function LeadTable({
  leads,
  selectedId,
  onSelect,
  emptyMessage
}: LeadTableProps) {
  if (leads.length === 0) {
    return <p className="px-4 py-10 text-center text-sm text-slate-500" data-id="element-142" data-mp="1fzng9g4y0g9c">{emptyMessage}</p>;
  }
  return <div className="overflow-x-auto" data-id="element-143" data-mp="1b1m2naqad959">
      <table className="w-full border-collapse text-left text-xs" data-id="element-144" data-mp="4m1qptv68cna">
        <thead data-id="element-145" data-mp="4ncuhtom9kee">
          <tr className="border-b border-slate-200 bg-slate-50" data-id="element-146" data-mp="4jp4v5mali4y">
            {columns.map(column => <th key={column} scope="col" className="whitespace-nowrap px-3 py-2 font-semibold uppercase tracking-wide text-slate-500" data-id="element-147" data-mp="1b9wieoe4ooce">
                {column}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-148" data-mp="12bkjlz33yk8v">
          {leads.map(lead => {
          const isSelected = lead.id === selectedId;
          return <tr key={lead.id} onClick={() => onSelect(lead.id)} className={`cursor-pointer border-b border-slate-100 last:border-b-0 ${isSelected ? 'bg-[#eaf5fe]' : 'hover:bg-slate-50'}`} data-id="element-149" data-mp="siwpjc3iiudu">
                <th scope="row" className="px-3 py-2 text-left font-normal" data-id="element-150" data-mp="nk26qa5jp5tq">
                  <button type="button" onClick={event => {
                event.stopPropagation();
                onSelect(lead.id);
              }} className="flex items-center gap-1.5 text-left font-semibold text-[#0176d3] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3]" aria-current={isSelected} data-id="element-151" data-mp="nhz7r0mf02cv">
                    {lead.urgent && <AlertTriangleIcon className="h-3.5 w-3.5 shrink-0 text-[#ba0517]" aria-label="Urgent" data-id="element-152" data-mp="27e4y39gf9ejq" />}
                    {lead.name}
                  </button>
                  <span className="text-[11px] text-slate-500" data-id="element-153" data-mp="2v7eqsw28og6g">{lead.id}</span>
                </th>
                <td className="whitespace-nowrap px-3 py-2 font-medium text-slate-900" data-id="element-154" data-mp="2q5pe7bzdbug9">
                  {formatCurrency(lead.loanAmount)}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-155" data-mp="1erkbsneszsn1">
                  {formatShortDate(lead.seasoningDate)}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-156" data-mp="19rfq8iz1g7py">
                  {lead.loanType}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-157" data-mp="14nwsy3ahdmo6">
                  {formatShortDate(lead.creditPullDate)}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-158" data-mp="19m85ils5uba3">
                  {lead.stage}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-159" data-mp="1eft4ag1kv9ac">
                  {lead.disposition}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-slate-700" data-id="element-160" data-mp="1ndvb5c7zsw5j">
                  {lead.touches.length}
                </td>
                <td className="whitespace-nowrap px-3 py-2" data-id="element-161" data-mp="1se0vs8fuhie4">
                  <ReviewBadge review={lead.review} data-id="element-162" data-mp="1xd42ryfdxyoq" />
                </td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}